<div class="sml-editor" [formGroup]="optionsForm">
  <div class="sml-editor__field">
    <label class="sml-editor__field-label">Price Display</label>
    <pdq-dropdown
      formControlName="priceDisplay"
      [options]="priceDisplayOptions"
      [defaultOption]="currentPriceDisplay"
      [fullWidth]="true">
    </pdq-dropdown>
  </div>

  <div class="sml-editor__field">
    <pdq-checkbox formControlName="allowShopperToChangeMethod" label="Allow shopper to change shipping method">
    </pdq-checkbox>
  </div>

  <div class="sml-editor__field">
    <label class="sml-editor__field-label">Eligible Methods</label>
    @let methodOptions = allowedMethodOptions$ | async;
    <pdq-dropdown
      selectBy="checked"
      [options]="methodOptions ?? []"
      [defaultOption]="methodOptions ?? []"
      [loading]="!methodOptions"
      [disabled]="!methodOptions"
      [multiSelect]="true"
      [enableSearch]="true"
      [showSelectUnselectOptions]="false"
      [concatinatedLabelOptionsThreshold]="3"
      [fullWidth]="true"
      placeholder="Select shipping methods"
      (onMultiSelectChange)="onAllowedMethodsChange($event)">
    </pdq-dropdown>
    @if (optionsForm.get('allowedMethodNames').errors?.required && !optionsForm.get('allowAllMethods').value) {
      <div class="sml-editor__error">*At least one method required</div>
    }
  </div>

  @if (optionsForm.get('allowShopperToChangeMethod').value) {
    <div class="sml-editor__field">
      <label class="sml-editor__field-label">Button Label</label>
      <rich-textarea
        [initialContent]="initialButtonLabel"
        placeholder=""
        [disabledFormats]="['list:ordered', 'align']"
        (contentChange)="onButtonLabelChange($event)">
      </rich-textarea>
    </div>
  }
</div>
